module.exports = __webpack_public_path__ + "img/air-conditioner-icon.2c4eef93.svg";